module.exports = __webpack_public_path__ + "static/top-e3ec5542cb9d4999b30214981d62d719.png";